// Copyright (c) Microsoft. All rights reserved. Licensed under the MIT license. See full license in the root of the repo.
/*
    This file provides the provides functionality to get Microsoft Graph data.
*/
import * as $ from "jquery";

export async function getMessagesList(token, conversationId, ownerEmail) {
  const response = await $.ajax({
    type: "POST",
    url: `/messages-list`,
    data: JSON.stringify({ conversationId, ownerEmail }),
    contentType: "application/json",
    headers: { Authorization: "Bearer " + token },
    cache: false,
  });

  return response;
}

export async function getAIEmailResponse(payload) {
  const response = await $.ajax({
    type: "POST",
    url: `/outlook-email-concierge`,
    data: JSON.stringify(payload),
    contentType: "application/json",
    cache: false,
  });

  return response;
}
